var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vl-layer-vector',{attrs:{"visible":_vm.activeGridOverlay,"extent":_vm.imageExtent,"update-while-animating":true,"update-while-interacting":true}},[_c('vl-source-vector',{attrs:{"features":_vm.grid}}),_c('vl-style-box',[_c('vl-style-stroke',{attrs:{"color":_vm.color}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }